import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { termsAndConditionsContent } from "../redux/features/footerPages/footerPagesContentSlice";
import { FaSpinner } from "react-icons/fa";

const TermsAndCondition = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.language.lang);

  const {
    termsAndConditionsContent: contentData,
    status,
    error,
  } = useSelector((state) => state.footerPagesContent);

  const [modifiedHtml, setModifiedHtml] = useState("");

  useEffect(() => {
    const api_token = localStorage.getItem("api_token");
    dispatch(termsAndConditionsContent({ api_token, lang }));
  }, [dispatch, lang]);

  useEffect(() => {
    if (contentData?.data?.content) {
      const htmlString = contentData.data.content;
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      // 🪄 Add Bootstrap classes dynamically for consistent styling
      doc.querySelectorAll("h2, h3, h4, h5").forEach((el) => {
        el.classList.add("text-dark", "mb-4", "fw-bold");
      });

      doc.querySelectorAll("p").forEach((el) => {
        el.classList.add("fs-6", "text-muted");
        const hr = document.createElement("hr");
        el.parentNode.insertBefore(hr, el.nextSibling);
      });

      doc.querySelectorAll("strong").forEach((el) => {
        el.classList.add("ms-1");
      });

      setModifiedHtml(doc.body.innerHTML);
    }
  }, [contentData]);

  return (
    <>
      {/* 🏷️ Page Header */}
      <div className="container-fluid faq-heading">
        <div className="row">
          <h1 className="text-center">
            {contentData?.data?.title || t("Terms & Conditions")}
          </h1>
          <p className="text-center">{contentData?.data?.sub_title}</p>
        </div>
      </div>

      {/* 📄 Content Section */}
      <div className="container my-5">
        <div className="row">
          <div className="col-12">
            {status === "loading" && (
              <div className="text-center my-5">
                <FaSpinner className="spin fs-2" />
              </div>
            )}

            {status === "failed" && (
              <div className="alert alert-danger text-center" role="alert">
                {t(
                  "Failed to load Terms and Conditions. Please try again later."
                )}
              </div>
            )}

            {status === "succeeded" && (
              <div className="card shadow border-0 rounded-0 overflow-hidden">
                <div className="card-body bg-light">
                  <div
                    className="terms-content"
                    dangerouslySetInnerHTML={{
                      __html: modifiedHtml || "",
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndCondition;
